import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { updateLeadsLife } from "../../Redux/LogsRedux/Life/LifeLeadsRedux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export default function ChoosePlan() {
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = location.state || {};
  const dispatch = useDispatch();
  const { t } = useTranslation();
  

  const handleSubmit = (plan) => {
    const payload = {
      transId: localStorage.getItem("LIFE_LEAD_ID"),
      selectedCoverPlan: plan,
      leadStatus: "UPDATED",
    };
    dispatch(updateLeadsLife(payload)).then((response) => {
      if (response.success) {
        navigate("/basic-information", {
          state: { planDetails: { coverPlan: plan, ...userDetails } },
        });
      }
    });
  };

  const handleKeyPress = (e, plan) => {
    // trigger click on Enter or Space for accessibility
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleSubmit(plan);
    }
  };
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-6 p-3">
          <div className="row p-4 mb-1 planCardWrapoper">
            <h4 className="title p-0 py-3">{t("Choose your product")}</h4>
            <div
              className="plan-card mb-3 d-flex justify-content-between align-items-center"
              onClick={() => {
                handleSubmit("Personal Accident");
              }}
              tabIndex={0}
              role="button"
              onKeyDown={(e) => handleKeyPress(e, "Personal Accident")}
            >
              <span className="plan-text">{t("Personal Accident")}</span>
              <i className="bi bi-person-hearts plan-icon"></i>
            </div>
            <div
              className="plan-card mb-3 mt-1 d-flex justify-content-between align-items-center"
              tabIndex={0}
              role="button"
              onKeyDown={(e) => handleKeyPress(e, "Term Plan")}
              onClick={() => {
                handleSubmit("Term plan");
              }}
            >
              <span className="plan-text">{t("Term plan")}</span>
              <i className="bi bi-heart-pulse plan-icon"></i>
            </div>

            {/* <div className="bottom-container mt-2  rounded-5">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="col-5">
                                <h6
                                    className="m-0 "
                                    style={{ fontSize: "20px" }}
                                >
                                    Unified Health Insurance Plan
                                </h6>
                            </div>
                            <div className="col-7 d-flex align-items-center justify-content-center gap-4">

                                <img
                                    className="bg-dark rounded-5"
                                    src={unifiedLogo2}
                                    alt="logo"
                                />
                                <img
                                    src={unifiedLogo1}
                                    alt="logo"
                                    className="p-2 rounded-5"
                                />
                            </div>
                        </div> 
                    </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
